import { hot } from 'react-hot-loader/root';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import ArchetypeSelector from '../components/ArchetypeSelector';
import Briefcase from '../components/BriefcaseIcon';
import ShopifyProducts from '../components/ShopifyProducts';
import PageSection from '../design-system/PageSection';
import PageWrapper from '../design-system/PageWrapper';
import Paragraph from '../design-system/Paragraph';
import RichText, { HeadlineRenderer } from '../design-system/RichText';
import {
  HeadingPara,
  HeadingLabel,
  HeadingSub,
  HeadingSection,
} from '../design-system/Headings';
import AccountSubNav from '../components/AccountSubNav';
import LaserBannerPageSection from '../design-system/LaserBannerPageSection';

import shopifyConfigType from '../proptypes/shopify-config';
import phrasesType from '../proptypes/phrases';
import { camelize, underscore } from '../utils/stringUtils';
import careersType from '../proptypes/careers';

const FETCH_OPTIONS = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  redirect: 'follow',
};

const CareersPage = ({
  id,
  introduction,
  careers,
  phrases,
  roles,
  shopifyConfig,
  shopifyCollection,
}) => {
  const [content, setContent] = useState({ id, introduction, careers });

  const handleChangeRole = async (camelizedId) => {
    const roleId = underscore(camelizedId);
    const roleUrl = `${window.location.pathname}?id=${roleId}`;
    const response = await fetch(roleUrl, FETCH_OPTIONS);

    setContent(await response.json());
  };

  return (
    <PageWrapper tallNav bgDark className="careers-page">
      <AccountSubNav />
      <LaserBannerPageSection>
        <HeadingSection el="h1" my0>
          {phrases.careers.title}
        </HeadingSection>
      </LaserBannerPageSection>
      <PageSection>
        <HeadingLabel>{roles[camelize(content.id)]}</HeadingLabel>
        <RichText
          paragraphRenderer={HeadlineRenderer}
          content={content.introduction}
        />
      </PageSection>
      <LaserBannerPageSection>
        <HeadingPara>
          <Briefcase />
          <br />
          {phrases.careers.potentialRolesForYou}
        </HeadingPara>
        <div className="row careers sm-careers--alternate md-careers--2x2 lg-careers--alternate xl-careers--alternate">
          {map(content.careers, ({ title, description }) => (
            <div className="career col-lg-4 col-md-6 col-12 my-4" key={title}>
              <div className="content">
                <HeadingSub>{title}</HeadingSub>
                <Paragraph my0>{description}</Paragraph>
              </div>
            </div>
          ))}
        </div>
      </LaserBannerPageSection>
      <PageSection borderT center bgDarkMid>
        <ArchetypeSelector
          archetypes={Object.keys(roles).map(roleId => ({
            id: roleId,
            name: roles[roleId],
          }))}
          onClick={handleChangeRole}
          phrases={phrases.careers}
        />
      </PageSection>
      <PageSection borderT className="shopify-products-section" center>
        <HeadingPara>{phrases.shopify.sectionTitle}</HeadingPara>
        <ShopifyProducts
          config={shopifyConfig}
          collectionId={shopifyCollection}
          count={6}
          linkText={phrases.shopify.purchaseButtonTitle}
        />
      </PageSection>
    </PageWrapper>
  );
};

CareersPage.propTypes = {
  id: PropTypes.string.isRequired,
  introduction: PropTypes.string.isRequired,
  careers: careersType,
  phrases: phrasesType.isRequired,
  roles: phrasesType.isRequired,
  shopifyConfig: shopifyConfigType.isRequired,
  shopifyCollection: PropTypes.string.isRequired,
};

CareersPage.defaultProps = {
  careers: [],
};
export default hot(CareersPage);
